<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card flat class="dt-border pad-10">
            <v-btn icon absolute top right @click="$emit('closeModal')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <br>
            <v-card-title class="d-flex justify-center">
                <p class="text-center text-capitalize">UPDATE {{ name(setting.key) }}</p>
            </v-card-title>
            <v-card-text>
                <v-text-field style="border-color: red" color="auto" label="Set New Value" :value="setting.value" outlined
                    v-model="newValue"></v-text-field>
                <p><span class="error--text"> Note: </span> This action is critical and will affect the mobile application
                    users. Please check the box below to confirm action </p>
                <v-checkbox v-model="checkbox" color="auto" label='Please tick to confirm action'></v-checkbox>
                <br />
                <default-button :loading="loading" :disabled="!isComplete" @click="updateSettings()">UPDATE</default-button>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
// ================ IMPORT COMPONENTS ================
import DefaultButton from "@/components/Buttons/default-button.vue";

// =========== IMPORT SERVICES ===========
import { AppService, CryptoService } from '@/services';

export default {
    data: () => ({
        loading: false,
        checkbox: false,
        newValue: ''
    }),
    components: {
        DefaultButton,
    },
    mounted() {
        this.newValue = this.setting.value
    },
    props: {
        setting: {
            type: Object
        },
        dialog: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        isComplete() {
            return this.checkbox
        }
    },
    methods: {
        name(name) {
            return name.replace(/-/g, ' ')
        },
        async updateSettings() {
            try {
                this.loading = true;
                if (this.setting.key != 'Automate Coin Trade Limit') {
                    const data = await AppService.updateSettings({
                        key: this.setting.key,
                        value: this.newValue
                    })
                    this.loading = false;
                    data['editable'] = false
                    this.$emit('closeModal');
                    this.$emit('update', data)
                }
                else {
                    console.log('entered the crypto settings');
                    const data = await CryptoService.setSettings({ "automatic": false, "maxAutomatic": this.newValue });
                    if (data) {
                        const automatic ={created: data.created,
                     updated: data.updated, deleted: data.deleted,
                    key: 'Automate Coin Trade Limit', id: data.id, value: data.maxAutomatic,
                    editable: false};
                        this.loading = false;
                        this.$emit('closeModal');
                        this.$emit('update', automatic);
                    }
                }
            } catch (error) {
                this.loading = false
            }
        }
    }
}
</script>